<div class="io-item io-item-shadow" [ngClass]="{clickable:isClickable}"
    [routerLink]="isClickable == false ? null : (item?.level == 'USER' ? ['/', 'admin', 'users', item.forUserId] : ['/', 'admin', 'users', item.forUserId, 'transactions', item.transaction?.id])">
    <div class="main">
        <mat-icon class="status d-none d-l-show" *ngIf="!item.resolved" color="warn">error</mat-icon>
        <mat-icon class="status done d-none d-l-show" *ngIf="item.resolved" color="success">check_circle</mat-icon>
        <div class="data subject">
            <small>{{ 'Subject' | translate}}</small>
            <span>
                {{item?.flag?.name}}
                <!-- {{ mylocalize(('FLAG_' + item.flag.presentedCode), ('FLAG_' + item.flag.presentedCode) | translate,
                ('FLAG_' + item.flag.presentedCode+'_'+userCountry),
                ('FLAG_' + item.flag.presentedCode+'_'+userCountry) | translate) }} -->
            </span>
        </div>

        <div class="data status">
            <span>
                <!-- <span class="tag no-flex" *ngIf="item?.flag?.isWarning">Warning</span> -->
                <span class="tag no-flex" *ngIf="!item?.flag?.isWarning">Action Needed</span>
            </span>
        </div>
        <div class="data status">
            <small>{{ 'Level' | translate}}</small>
            <span>
                {{ (item?.level == 'USER' ? 'User' : "Transaction") | translate }}
            </span>
        </div>
        <div class="data user">
            <small *ngIf="item?.user">{{ 'User' | translate}}</small>
            <small *ngIf="item?.transaction">{{ 'Transaction' | translate}}</small>
            <span>
                {{item?.user?.firstName}}
                {{item?.user?.middleName}}
                {{item?.user?.lastName}}
                {{item?.transaction?.transactionId}}
            </span>
        </div>

        <div class="data user">
            <small>{{ 'Created' | translate}}</small>
            <span matTooltip="{{ item?.created | timezone | date }}">
                {{item?.created | timezone | date }}
            </span>
        </div>

        <button class="button" mat-icon-button click-stop-propagation (click)="onExpand($event, item)">
            <mat-icon *ngIf="!expanded">expand_more</mat-icon>
            <mat-icon *ngIf="expanded">expand_less</mat-icon>
        </button>

    </div>
    <div [ngClass]="{expand:true, open: expanded}" click-stop-propagation>

        <table class="table-details">
            <tbody>
                <tr>
                    <th>{{ 'Created' | translate }}</th>
                    <td>{{ item?.created | timezone | date }}</td>
                </tr>
                <tr>
                    <th>{{ 'Created by' | translate }}</th>
                    <td>{{ item?.createdByName | noData }}</td>
                </tr>
            </tbody>
        </table>
        <app-json-renderer [items]="item?.description"></app-json-renderer>
        <table class="table-details">
            <tbody>
                <tr>
                    <th>{{ 'Resolved' | translate }}</th>
                    <td>{{ item?.resolved | timezone | date | noData }}</td>
                </tr>
                <tr>
                    <th>{{ 'Resolved by' | translate }}</th>
                    <td>{{ item?.resolvedBy?.firstName }} {{ item?.resolvedBy?.lastName }}</td>
                </tr>
                <tr>
                    <th>{{ 'Resolved Note' | translate }}</th>
                    <td>{{ item?.resolvedNote | noData }}</td>
                </tr>
            </tbody>
        </table>

        <mat-action-row style="padding-top: 24px;" class="io-row-m"
            *ngIf="!item.resolved && auth.hasPermission(auth.perm.FlagsManage) || (item.ticket && auth.hasPermission(auth.perm.FlagsRead)) || (!item.resolved && !item.ticket && auth.hasPermission(auth.perm.FlagsManage))">
            <div class="flex">

            </div>
            <button mat-stroked-button class="resolve-btn" class="no-m-flex" (click)="mls.removeFlag(item);"
                *ngIf="!item.resolved && auth.hasPermission(auth.perm.FlagsManage)">
                {{ 'Resolve' | translate }}
            </button>
            <button mat-raised-button color="primary" *ngIf="item.ticket && auth.hasPermission(auth.perm.FlagsRead)"
                class="no-m-flex"
                [routerLink]="['/','admin','users', item.forUserId, 'tickets','ticket', item.ticket.id]">
                {{ 'View Ticket' | translate }}
            </button>
            <button mat-raised-button color="primary" class="no-m-flex"
                *ngIf="!item.resolved && !item.ticket && auth.hasPermission(auth.perm.FlagsManage) && ['WATCHLIST_HIT', 'KYC_PEP'].indexOf(item?.flag?.code) == -1"
                (click)="mls.createTicket(item, item.forUserId, item.transaction?.id);">
                {{ 'Add Ticket' | translate }}
            </button>
        </mat-action-row>
    </div>
</div>